/**
 * Brand-independent colour tokens (DIS-1844): the Figma "Universal/*" variables from
 * "Loyalty Sign-Up Redesign" (file JNExbbbe4KI568IdRlm8Rh, nodes 160:8315, 536:4247).
 *
 * Brand colours (primary, heading, button) are NOT here. They differ per brand and
 * stay in theme.colour.* from assets/common/theme/{brand}/theme.js.
 *
 * Field chrome is NOT here either. app/design-system/tokens/fieldPalette.ts holds
 * the at-rest border as its own #757575 literal (DIS-1854). That matches
 * greyDark's hex, but fields do not read greyDark, so a later greyDark edit
 * does not move the border.
 */
export const universal = Object.freeze({
  black: '#000000',
  white: '#FFFFFF',
  /** Universal/Grey - Dark. Input border in the sign-up frames. */
  greyDark: '#757575',
  /** Universal/Grey - Medium. Desktop card border. */
  greyMedium: '#E0E0E0',
  /** Universal/Discount Red. Required-field mark. */
  discountRed: '#ED1A3B',
} as const);

/**
 * Form error text and the error border (DIS-1853). Not a Universal/* Figma
 * variable, and not rewardsTheme.error: payment and password-reset reds stay
 * on the theme. #F0526C on white is about 3.43:1, under 4.5:1 for normal text.
 * #C81E1E on white is about 5.74:1.
 */
export const FIELD_ERROR_COLOR = '#C81E1E';
